export default __webpack_public_path__ + "static/quadra-7860f47715b4f6bef8e99a23d2d4f003.jpg";